<div>
	<app-class-breakdown [report]="report()" />

	<app-student-reports [report]="report()" (selectStudent)="selectStudent($event)"></app-student-reports>
</div>
